import { css } from '@emotion/react'

const logoCss = ({ colors }) => css`
  width: 58px;
  height: 34px;
  font-weight: 500;
  letter-spacing: -0.88px;
  font-size: 28px;
  line-height: 1.2;
  margin-right: 11px;
  color: ${colors.black};
  text-decoration: none;
`

export default () => (
  <a
    alt={process.env.GATSBY_PRODUCT_LABEL}
    rel="noopener noreferrer"
    href={process.env.GATSBY_PRODUCT_WEBSITE_URL}
  >
    <span css={logoCss}>text|</span>
  </a>
)
